export default __webpack_public_path__ + "static/media/rastech-sat.f23fcddb.jpg";